<template>
  <a-drawer
    title="推荐医生记录"
    placement="right"
    :width="900"
    :visible="visible"
    :closable="true"
    @close="onClose"
    destroyOnClose
  >
    <!-- 择医条件提示 -->
    <div v-if="currentChoose" class="choose-condition-info">
      <a-alert type="info" show-icon>
        <template slot="message">
          <span class="condition-label">择医筛选条件：</span>
          <span v-if="currentChoose.illnessName" class="condition-item">
            <a-tag color="blue">病症：{{ currentChoose.illnessName }}</a-tag>
          </span>
          <span v-if="currentChoose.range" class="condition-item">
            <a-tag color="green">范围：{{ currentChoose.range === 1 ? '市' : currentChoose.range === 2 ? '省' : '全国' }}</a-tag>
          </span>
          <span v-if="currentChoose.cityProvinceName" class="condition-item">
            <a-tag color="orange">地区：{{ currentChoose.cityProvinceName }}</a-tag>
          </span>
          <span v-if="currentChoose.patientType" class="condition-item">
            <a-tag color="purple">患者类型：{{ currentChoose.patientType === 1 ? '儿童' : '成人' }}</a-tag>
          </span>
          <span class="condition-item">
            <a-tag color="red">推荐医师数量：{{ doctorList.length }}名</a-tag>
          </span>
        </template>
      </a-alert>
    </div>

    <!-- 医生列表区域 -->
    <a-table
      :loading="loading"
      :size="'default'"
      rowKey="id"
      :columns="doctorColumns"
      :data-source="doctorList"
      :pagination="false"
      :bordered="true"
      :scroll="{ x: 850 }"
    >
      <span slot="logo" slot-scope="text, record">
        <img v-viewer v-if="record.logo" :src="processImageUrl(record.logo)" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;" />
        <span v-else>-</span>
      </span>
      <span slot="hospitalName" slot-scope="text, record">
        <a-tooltip v-if="record.hospitalName" placement="topLeft">
          <template slot="title">
            {{ record.hospitalName }}（{{ record.departName || '-' }}）
          </template>
          <span style="max-width: 150px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ record.hospitalName }}（{{ record.departName || '-' }}）</span>
        </a-tooltip>
        <span v-else>-</span>
      </span>
      <span slot="name" slot-scope="text, record">
        {{ text }}
      </span>
      <span slot="professional" slot-scope="text, record">
        <dict-tag :options="dict.type['doctor_professional']" :value="record.professional" />
      </span>
      <span slot="strongPoint" slot-scope="text, record">
        <a-tooltip v-if="text" placement="topLeft">
          <template slot="title">
            {{ text }}
          </template>
          <span style="max-width: 100px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ text }}</span>
        </a-tooltip>
        <span v-else>-</span>
      </span>
      <span slot="score" slot-scope="text, record">
        {{ text !== null && text !== undefined ? Number(text).toFixed(1) : '-' }}
      </span>
    </a-table>

    <!-- 空状态 -->
    <a-empty v-if="!loading && doctorList.length === 0" description="暂无推荐医生记录" style="margin-top: 40px;" />

    <!-- 底部操作区 -->
    <div class="drawer-footer">
      <a-button @click="onClose">
        关闭
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { pageDoctor } from '@/api/user/doctor'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'RecommendDoctorModal',
  dicts: ['doctor_professional'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentChoose: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      doctorList: [],
      doctorColumns: [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          width: 200,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'hospitalName' },
        },
        {
          title: '医师形象',
          dataIndex: 'logo',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'logo' },
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '职称',
          dataIndex: 'professional',
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'professional' }
        },
        {
          title: '荣誉',
          dataIndex: 'honor',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '擅长领域',
          dataIndex: 'strongPoint',
          width: 200,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'strongPoint' }
        },
        {
          title: '华歧系数',
          dataIndex: 'score',
          width: 100,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'score' }
        },
      ]
    }
  },
  watch: {
    visible(val) {
      if (val && this.currentChoose) {
        this.getDoctorList()
      }
    }
  },
  methods: {
    processImageUrl,
    onClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    getDoctorList() {
      if (!this.currentChoose || !this.currentChoose.id) {
        return
      }
      this.loading = true
      const param = {
        chooseId: this.currentChoose.id,
        pageNum: 1,
        pageSize: 100 // 获取所有推荐医生
      }
      pageDoctor(param).then(res => {
        if (res.success && res.data) {
          this.doctorList = res.data.records || []
        } else {
          this.doctorList = []
        }
        this.loading = false
      }).catch(err => {
        console.error('获取推荐医生列表失败', err)
        this.doctorList = []
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
/* 择医条件提示 */
.choose-condition-info {
  margin-bottom: 16px;
}

.choose-condition-info .condition-label {
  font-weight: 500;
  margin-right: 8px;
}

.choose-condition-info .condition-item {
  margin-right: 8px;
}

/* 底部操作区 */
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}
</style>
